import React from 'react';
import { Button, Table, Tooltip, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { utcToDefaultFormat } from '../../../Utils/date';
import PrintPrice from '../../../Components/PrintPrice';
import './styles.scss'
import PrintStatus from '../PrintStatus';

const { Column } = Table;

function PrintBalance({ 
  balance
}) {
  return (
    <span style={balance < 0 ? { color: 'red' } : null}>
      <PrintPrice price={balance} />
    </span>
  );
}

PrintBalance.propTypes = {
  balance: PropTypes.number.isRequired,
};

function PrintAmount({ amount }) {
  return (
    <span style={amount > 0 ? { color: 'green' } : null}>
      <PrintPrice price={amount} />
    </span>
  );
}

PrintAmount.propTypes = {
  amount: PropTypes.number.isRequired,
};

function ReplenishmentTable({
  handleFetch,
}) {
  const { payload, isLoading } = useSelector((state) => state.balance.list_replenishments);

  return (
    <Table
      bordered
      className="ant-table-white-bg"
      dataSource={(payload && payload) || null}
      loading={isLoading}
      pagination={false}
      rowKey={(obj) => 
        `${obj.id}_${obj.amount}_${obj.status}`
      }
    >
      {/* <Column
        title=""
        dataIndex="type"
        render={(type) => <span>{type === 'ord' ? <Tooltip title="Order"><ShoppingCartCheckoutOutlined /></Tooltip> : <Tooltip title="Invoice"><ReceiptOutlined /></Tooltip>}</span>}
      /> */}
      <Column
        title={`Replenishment ID`}
        dataIndex="id"
        render={(id) => <span>{id}</span>}
      />
      <Column
        title="Created"
        dataIndex="cre"
        render={(cre) => utcToDefaultFormat(cre)}
      /> 
      {/* <Column
        title="Replenished"
        dataIndex="cre"
        render={(creDate) => utcToDefaultFormat(creDate)}
      /> */}
      <Column
        title="Amount, $"
        dataIndex="amount"
        render={(amount) => <PrintAmount amount={amount} />}
      />
      <Column
        title="Status"
        dataIndex="status"
        render={(status) => <PrintStatus status={status} fetch={handleFetch} />}
      />
    </Table>
  );
}

export default ReplenishmentTable;
